import { FC, PropsWithChildren, useMemo } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import {
	loadStripe,
	StripeElementLocale,
	StripeElementsOptions,
} from '@stripe/stripe-js';

import { useI18nLanguage } from '@mopla/utils';

import { usePaymentEnv } from '../../context/paymentEnvContext';

export interface IStripePaymentContainerProps extends PropsWithChildren {
	stripeClientSecret?: string;
	stripeElementsOptions?: StripeElementsOptions;
}

export const StripePaymentContainer: FC<IStripePaymentContainerProps> = ({
	stripeClientSecret,
	children,
	stripeElementsOptions,
}) => {
	const { stripePublicKey } = usePaymentEnv();
	const language = useI18nLanguage();

	const stripePromise = useMemo(
		() => loadStripe(stripePublicKey),
		[stripePublicKey]
	);

	const resultOptions: StripeElementsOptions = useMemo(() => {
		const _options: StripeElementsOptions = {
			appearance: { theme: 'stripe' },
			locale: language
				? (language.substring(0, 2) as StripeElementLocale)
				: 'auto',
			...stripeElementsOptions,
		};

		if (stripeClientSecret && _options.mode === undefined) {
			_options.clientSecret = stripeClientSecret;
		}

		return _options;
	}, [language, stripeClientSecret, stripeElementsOptions]);

	return (
		<Elements stripe={stripePromise} options={resultOptions}>
			{children}
		</Elements>
	);
};
